<template>
  <div class="recommendDialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" center>
      <div style="text-align: center;font-size: 20px;" v-if="state === 0">
        <el-radio v-model="radio" label="1">推 荐</el-radio>
        <el-radio v-model="radio" label="2">自 荐</el-radio>
      </div>
      <div class="menu1" v-if="state === 1">
        <div class="block">
          <span class="demonstration">自我评分</span>
          <el-rate class="icon" v-model="value"></el-rate>
        </div>
        <div class="textInput">
          <span class="demonstration">总体评价</span>
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
          </el-input>
        </div>
      </div>
      <div class="menu1" v-if="state === 2">
        <div class="block">
          <span class="demonstration">评分</span>
          <el-rate class="icon" v-model="value1"></el-rate>
        </div>
        <div class="textInput">
          <span class="demonstration">评价</span>
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea1">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="state === 0">
        <el-button @click="dialogVisible = false">返回</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="state === 1">
        <el-button @click="back">返回</el-button>
        <el-button type="primary" @click="submit1">提交</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="state === 2">
        <el-button @click="back">返回</el-button>
        <el-button type="primary" @click="submit2">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        title: '请选择推荐方式',
        dialogVisible: false,
        radio: '1',
        value: '',
        textarea: '',
        value1: '',
        textarea1: '',
        state: 0, //0 选择推荐方式 1 自荐 2 他荐
      }
    },
    methods: {
      nextStep() {
        if (this.radio === '1') {
          this.title = '自荐'
          this.state = 1
        } else {
          this.title = '他荐'
          this.state = 2
        }
      },
      submit1() {

      },
      submit2() {

      },
      back() {//初始化函数
        this.title = '请选择推荐方式'
        this.radio = '1'
        this.state = 0
        this.value1 = ''
        this.textarea1 = ''
        this.value = ''
        this.textarea = ''
      }
    }
  }
</script>

<style lang="less" scoped>
  // .el-dialog {
  //   width: 400px !important;
  // }

  .menu1 {
    .block {
      display: flex;
      height: 30px;
      margin-top: 25px;
      margin-left: 20px;

      .demonstration {
        width: 20%;
      }

      .icon {
        width: 80%;
      }
    }
  }

  .textInput {
    display: flex;
    margin-top: 25px;
    margin-left: 20px;

    .demonstration {
      width: 25%;
    }

    .el-input {}
  }
</style>
